import React from 'react';
import ShareAction from './ShareAction.jsx';
import { BRAND, PUBLIC_ORIGIN, HOCKEY, FOOTBALL } from './shareConfig';
import './ShareButton.css';

export function sharePath(path) {
  let page;
  try { page = new URL(path, 'https://hq.invalid'); } catch { return null; }
  if (page.origin !== 'https://hq.invalid') return null;
  const source = page.searchParams;
  if (page.pathname === '/matches/') {
    const query = new URLSearchParams();
    if (source.get('date')) query.set('date',source.get('date'));
    return '/matches/' + (query.toString() ? '?' + query.toString() : '');
  }
  if (FOOTBALL) {
    const params = new URLSearchParams();
    const copy = key => { if (source.get(key)) params.set(key, source.get(key)); };
    if (['/match','/lineup'].includes(page.pathname)) {
      const identity = (source.get('url') || '').match(/^hq:\/\/football\/([^/]+)\/([1-9]\d*)(?:\/laguppstallning)?$/);
      if (identity) { params.set('simulation',identity[1]); params.set('id',identity[2]); }
      else { copy('simulation'); copy('id'); }
      if (!params.get('simulation') || !/^[1-9]\d*$/.test(params.get('id') || '')) return null;
      return `/match?${params}`;
    }
    if (page.pathname.startsWith('/team/')) { try { decodeURIComponent(page.pathname.slice(6)); } catch { return null; } copy('serie'); }
    else if (['/series','/standings'].includes(page.pathname)) { copy('serie'); copy('vy'); copy('tab'); }
    else if (page.pathname === '/tips') copy('serie');
    else if (page.pathname === '/') copy('date');
    else if (page.pathname !== '/upcoming') return null;
    return `${page.pathname}${params.toString() ? `?${params}` : ''}`;
  }
  const params = new URLSearchParams();
  let kind;
  const copy = key => { if (source.get(key)) params.set(key, source.get(key)); };
  if (['/match', '/lineup'].includes(page.pathname)) {
    kind = 'match';
    if (HOCKEY) { copy('simulation'); copy('id'); }
    else {
      const match = (source.get('url') || '').match(/^https:\/\/stats\.innebandy\.se\/sasong\/(\d+)\/serie\/(\d+)\/match\/(\d+)(?:\/|$)/);
      if (!match) return null;
      ['season', 'competition', 'id'].forEach((key, index) => params.set(key, match[index + 1]));
    }
    copy('tab');
    if (HOCKEY && params.has('tab')) params.set('tab', ({standings:'table',lineup:'teams'})[params.get('tab')] || params.get('tab'));
  } else if (page.pathname.startsWith('/team/')) {
    kind = 'team';
    try { params.set('team', decodeURIComponent(page.pathname.slice(6))); } catch { return null; }
    copy('serie');
    if (!HOCKEY) copy('competition');
  } else if (['/series', '/standings'].includes(page.pathname)) {
    kind = 'series'; copy('serie'); copy(HOCKEY ? 'tab' : 'vy');
    if (HOCKEY && source.get('vy')) params.set('tab',source.get('vy') === 'spelschema' ? 'schedule' : 'table');
  } else if (page.pathname === '/tips') { kind = 'tips'; copy('serie'); }
  else if (page.pathname === '/upcoming') kind = 'schedule';
  else if (page.pathname === '/') { kind = 'day'; copy('date'); }
  else return null;
  return `/share/${kind}${params.toString() ? `?${params}` : ''}`;
}

export default function ShareButton({ path, title, label = 'Dela', disabled = false }) {
  if (HOCKEY && path?.startsWith("/match?")) {
    const params = new URLSearchParams(path.split("?")[1]);
    const identity = params.get("url")?.match(/^hq:\/\/hockey\/([^/]+)\/([^/]+)/);
    if (identity) { params.set("simulation", identity[1]); params.set("id", identity[2]); path = "/match?" + params; }
  }
  const linkPath = sharePath(path);
  const overview = linkPath?.startsWith('/matches/');
  const url = linkPath ? (overview ? window.location.origin : PUBLIC_ORIGIN) + linkPath : '';
  const previewUrl = linkPath && !FOOTBALL && !overview ? PUBLIC_ORIGIN + linkPath.replace(/(\/share\/[^?]+)(.*)/, '$1.png$2') : '';
  return <ShareAction url={url} title={title} brand={BRAND} previewUrl={previewUrl} label={label} disabled={disabled} />;
}
